export const validateValidAllergenSubmitEvalForm = (qaEvaluationFormDetail) => {
  const allergenDetails =
    qaEvaluationFormDetail?.productEvaForm?.[0]?.allergenDetails ?? [];

  if (allergenDetails?.length > 0) {
    const isInvalid = allergenDetails.some((allergen) => {
      return !!allergen?.specification && !allergen?.headerName;
    });

    return !isInvalid;
  }

  return true;
};

export const mappingReadOnlyAllergens = (readOnlyAllergens) => {
  let result = {};

  if (readOnlyAllergens) {
    Object.keys(readOnlyAllergens).forEach((key) => {
      // Convert the key to lowercase and assign the value
      result = {
        ...result,
        [key.toLowerCase()]: readOnlyAllergens[key],
      };
    });
  }

  return result;
};

export const validateBatchLotCodeSubmitEvalForm = (qaEvaluationFormDetail) => {
  const productEvaForm = qaEvaluationFormDetail?.productEvaForm ?? [];
 
  if (productEvaForm?.length > 0) {
    const invalidProductNames = productEvaForm
      .filter((product) => {
        const batchLotCode = product?.privateBrandProduct?.batchLotCode ?? '';
        return batchLotCode?.length > 100;
      })
      .map((product) => product?.privateBrandProduct?.productName ?? '');
 
    return {
      isValid: invalidProductNames.length === 0,
      invalidProductNames,
    };
  }
 
  return { isValid: true, invalidProductNames: [] };
};